import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class CanalSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: { pk: '0', label: 'Personal' },
			pk: 0,
			options: [
				{ pk: '0', label: 'Personal' },
				{ pk: '1', label: 'OTT' },
				{ pk: '2', label: 'Otros' },
			]
		};
	}

	static propTypes = {
		label: PropTypes.string,
		onChange: PropTypes.func,
		value: PropTypes.any,
		disabled: PropTypes.bool,
	}

	resetState() {
		this.setState({
			value: this.getOption(this.props.value),
			pk: this.props.value
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			value: this.getOption(nextProps.value),
			pk: nextProps.value
		});
	}



	getOption(value) {
		for (var i = 0; i < this.state.options.length; i++) {
			if (this.state.options[i].pk == value)
				return this.state.options[i];
		}
	}

	onChange(value) {
		var pk = (value ? value.pk : '');
		this.setState({
			value: value,
			pk: pk,
		});
		if (this.props.onChange) this.props.onChange(value);
	}


	render() {
		return (
			<div>
				<Input
					name="canal"
					value={(this.state.pk ? this.state.pk : "null")}
					onChange={(e) => {}}
					className="d-none"
					type="number" disabled={this.props.disabled} />
				<Select
					multi={false}
					value={this.state.value}
					onChange={(value) => this.onChange(value)}
					options={this.state.options}
					clearable={false}
					backspaceRemoves={true} disabled={this.props.disabled} >
				</Select>
			</div>
		);
	}
};

module.exports = CanalSelect;


// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/CanalSelect.js